<template>
  <img :src="alertSrc" alt="alert" />
</template>

<script>
import Alert from "@/images/alert_red.svg";

export default {
  name: "InvalidIcon",
  data() {
    return {
      alertSrc: Alert,
    };
  },
};
</script>

<style scoped>
img {
  margin: 0 0.125rem;
}
</style>
